import axios from 'axios'
import { openCart } from './cart-modal.js'

const getProductForm = () =>
    document.querySelector('#productForm') ||
    document.querySelector('form.productForm') ||
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector('form.pdp-form')

const updateButtonUI = (button, state) => {
    switch (state) {
    case 'loading':
        button.style.width = `${button.getBoundingClientRect().width}px`
        button.style.height = `${button.getBoundingClientRect().height}px`
        button.setAttribute('disabled', 'disabled')
        button.dataset.state = 'loading'
        break
    default:
        button.removeAttribute('style')
        button.removeAttribute('disabled')
        button.dataset.state = 'idle'
    }
}

const handleAddToCart = async (event) => {
    event.preventDefault()

    const button = event.target.closest('[data-add-to-cart]')
    const productForm = button?.closest('form') || getProductForm()
    if (!productForm || !button) return
    const formData = new FormData(productForm)
    formData.set('attributes[recent_id]', formData.get('id'))

    updateButtonUI(button, 'loading')

    try {
        await axios.post('/cart/add.js', formData)
    } catch (e) {
        console.error('Error adding product to cart')
        return
    }

    await syncRebuyCartFromShopify()

    if (tryOpenRebuySmartCart()) {
        updateButtonUI(button, 'idle')
        return
    }

    const opened = await getAndShowCartModal()
    if (!opened) {
        window.location.assign('/cart')
    }
    updateButtonUI(button, 'idle')
}

const syncRebuyCartFromShopify = () =>
    new Promise((resolve) => {
        if (typeof window.Rebuy?.Cart?.fetchShopifyCart !== 'function') {
            resolve()
            return
        }
        let settled = false
        const finish = () => {
            if (settled) return
            settled = true
            clearTimeout(timeoutId)
            resolve()
        }
        const timeoutId = setTimeout(finish, 2500)
        try {
            window.Rebuy.Cart.fetchShopifyCart(finish)
        } catch (e) {
            finish()
        }
    })

const tryOpenRebuySmartCart = () => {
    const smartCart = window.Rebuy?.SmartCart
    if (!smartCart) return false
    try {
        if (typeof smartCart.show === 'function') {
            smartCart.show()
            return true
        }
        if (typeof smartCart.open === 'function') {
            smartCart.open()
            return true
        }
    } catch (e) {
        console.warn('Rebuy Smart Cart could not open:', e)
    }
    return false
}

const getAndShowCartModal = async () => {
    const ATCModal = document.querySelector('.cartModal__wrapper')
    const inner = document.querySelector('[data-cart-modal-inner]')

    if (!ATCModal || !inner) {
        return false
    }

    try {
        const cartSectionResponse = await axios.get('?sections=cart-modal,cart-indicator')
        inner.innerHTML = cartSectionResponse.data['cart-modal']
        const indicator = document.querySelector('[data-cart-indicator]')
        if (indicator) {
            indicator.innerHTML = cartSectionResponse.data['cart-indicator']
        }
        openCart()
        return true
    } catch (e) {
        console.error('Error getting cart section html')
        return false
    }
}

document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-add-to-cart]')) return
    handleAddToCart(event)
})
